export default class TestimonialsCarousel {
    #slider = null;
    #tabs = [];

    constructor() {
        const maxRetries = 50;
        let attempt = 0;
        const interval = setInterval(() => {
            attempt++;
            if (attempt >= maxRetries) {
                console.log('Ran out of attempts');
                clearInterval(interval);
                return;
            }
            this.#slider = document.querySelector('.customer--testimonial__videos .slick-slider');
            this.#tabs = document.querySelectorAll('.customer--testimonial__item');
            if (this.#slider && this.#tabs) {
                clearInterval(interval);
                this.listenOnTabClicks();
                this.listenOnSlideChange();
            }
        }, 100)
    }

    listenOnTabClicks() {
        this.#tabs.forEach((tab, index) => {
            console.log(`Add event to tab ${index}`);
            tab.addEventListener('click', () => {
                this.onTabClick(index);
            })
        });
    }

    listenOnSlideChange(){
        jQuery(this.#slider).on('afterChange', (event, slick, index) => {
           this.activateTab(index);
        });
    }

    onTabClick(index) {
        this.#slider.slick.slickGoTo(index);
        this.activateTab(index);
    }

    activateTab(index) {
        this.#tabs.forEach((tab, i) => {
            tab.classList.remove('active');
        });

        const tab = this.#tabs[index];
        if (tab) {
            tab.classList.add('active');
        }
    }
}